import React, { memo } from 'react';
import styled from 'styled-components';

const Text = styled.text`
  font-size: 9px;
  fill: #17181a;
`;

type Props = {
  value: number;
};

const SvgSkiLuggage = ({ value }: Props) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M4 15.625a1 1 0 0 1 1-1h13.29a1 1 0 0 0 .362-.068l.7-.27c.433-.168.95-.019 1.078.428.066.231.088.477-.017.67-.15.28-.715.736-1.195 1.093a2.753 2.753 0 0 1-1.646.522H5a1 1 0 0 1-1-1v-.375zm0 4a1 1 0 0 1 1-1h13.29a1 1 0 0 0 .362-.068l.7-.27c.433-.168.95-.019 1.078.428.066.231.088.477-.017.67-.15.28-.715.736-1.195 1.093a2.753 2.753 0 0 1-1.646.522H5a1 1 0 0 1-1-1v-.375z"
      stroke="#17181A"
    />
    <path d="M9.262 15.794h4.076m-4.076 4.001h4.076" stroke="#17181A" />
    <Text dx="8" dy="12">
      {value}
    </Text>
  </svg>
);

const Memo = memo(SvgSkiLuggage);
export default Memo;
